<template>
     <div class="mx-5 mx-sm-10 mx-md-16 px-md-16 my-6" >
         <div class="row align-center">
            <div class="col-2 col-sm-1 py-0 pl-5  pl-md-5 text-center rounded">
                <img :src="`${require('@/assets/Sedes-LAB.png')}`" class="img-dialog-description">
            </div>
            <div class="col-10 col-sm-11 pt-2 pl-10  pl-md-0 orange--text">
                <h1 class="font-weight-black orange--text col" style="line-height:.5">LABORATORIO</h1>
                <h2 class='gray--text col' style="line-height:.5">Sede Guayaquil</h2>
            </div>
        </div>
        <v-col cols="12" class="gray--text"  style='display: inline-block;'>
            En nuestros laboratorios brindamos los más altos estándares de calidad, otorgando resultados precisos
            <br />
            y confiables. Contamos con la tecnología actualizada, el equipamiento específico y la infraestructura para
            <br />
            garantizar las reglas de bioseguridad. Nuestro personal está capacitado para llevar a cabo las tareas que
            <br/>
            realiza, brindando el respeto y la calidez que usted se merece.
        </v-col>
        <v-col cols="12"  class="gray--text">
            <b>Av. Francisco de Orellana y Justino Cornejo, Guayaquil, Ecuador</b>
            <br />
            Edificio World Trade Center, planta baja, Local 14)

            <p class="pt-5">Abierto de lunes a viernes de 8 a 18 hs y sábados de 9 a 13 hs.</p>
        </v-col>
        <v-col cols="12">
            <v-responsive >
                <iframe 
                    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15947.89237693024!2d-79.8976979!3d-2.1639403!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x5d19cfa4bfc48505!2sInnofarm%20-%20Medicina%20Integral%20de%20Especialidad!5e0!3m2!1ses!2sec!4v1616426952960!5m2!1ses!2sec" 
                    allowfullscreen="" 
                    loading="lazy"
                ></iframe>
            </v-responsive>
        </v-col>
  </div>
</template>

<script>
export default {
    name: 'LaboratoryGyeComponent',
}
</script>

<style>

</style>